import httpInstance from "../httpInstance";

export const getReservationsList = async (jwtToken: string, status: string | null, date: string | null, timezone: string | null) => {
    let res: any;
    const endpoint = `reservations`;

    const config = {
        headers: {
            Authorization: `${jwtToken}`
        },
        params: {
            status: status,
            date: date,
            timezone: timezone
        }
    };

    await httpInstance.get(endpoint, config)
        .then((data) => {
            res = data;
        })
        .catch((error) => {
            res = error.response;
        });
    return res;
}

export const getAdminReservationsList = async (jwtToken: string, status: string | null, date: string | null, timezone: string | null) => {
    let res: any;
    const endpoint = `adminReservations`;

    const config = {
        headers: {
            Authorization: `${jwtToken}`
        },
        params: {
            status: status,
            date: date,
            timezone: timezone
        }
    };

    await httpInstance.get(endpoint, config)
        .then((data) => {
            res = data;
        })
        .catch((error) => {
            res = error.response;
        });
    return res;
}